import { Modal } from 'antd';
import styled from 'styled-components';

const ModalSearchCustomer = styled(Modal)`

  form {
    max-height:  49vh;
  }

  width: 90% !important;

  /* .ant-modal {
    min-height: 550px;
    display: flex;
    align-items: center;
    justify-content: center;
  } */

  .ant-input-search-button {
    background-color: white;
    color: black;
    border-color: #F1F2F6;
    box-shadow: none;
  }
`;

export { ModalSearchCustomer };
